module.exports = __webpack_public_path__ + "img/code.d07566de.png";